import { AsyncStorage } from 'react-native';

export default class Storage {
    static BASE_STORAGE_KEY = '@Fitbeat:';

    static async get(key, defaultValue) {
        let value = null;

        try {
            value = await Storage.getItem(Storage.BASE_STORAGE_KEY + key);
            if (value !== null) {
                return value;
            }
            return defaultValue;
        } catch (error) {
            console.log('AsyncStorage', error.message);
        }
        return value;
    }

    static async getItem(fullKey) {
      return await AsyncStorage.getItem(fullKey);
    }

    static async set(key, value) {
        try {
            await Storage.setItem(Storage.BASE_STORAGE_KEY + key, value);
        } catch (error) {
            console.log('AsyncStorage', error.message);
        }
    }

    static async setItem(fullKey, value) {
      await AsyncStorage.setItem(fullKey, value);
    }

    static async remove(key) {
        try {
            await AsyncStorage.removeItem(Storage.BASE_STORAGE_KEY + key);
        } catch (error) {
            console.log('AsyncStorage', error.message);
        }
    }

    static async clear() {
        try {
            await AsyncStorage.clear();
        } catch (error) {
            console.log('AsyncStorage', error.message);
        }
    }
}
